import './styles/DeleteDraftButton.css';

const DeleteDraftButton = ({ onClick }) => {
  return (
    <div
      className="draft-delete-button"
      onClick={onClick}
    >
      <div />
    </div>
  );
};

export default DeleteDraftButton;
